import type { AnalyticsEventParamsType } from '@repo/analytics';
import { toGa4EventName } from './ga4-event-map';
import { ga4GtagAdapter } from './ga4-gtag-adapter';

export function trackEvent(eventName: string, params?: AnalyticsEventParamsType): void {
  if (typeof window === 'undefined') {
    return;
  }
  ga4GtagAdapter.track(toGa4EventName(eventName), params);
}
